import InputGroupContent from '@/components/elements/input'
import Select from '@/components/elements/select'
import TextareaGroupContent from '@/components/elements/textarea'
import { GeneralDetailsClothes } from '@/entities/api/products/details'
import ProductEntity from '@/entities/api/products/products'
import { ageMap } from '@/utils/maps/age-map'
import { genderMap } from '@/utils/maps/gender-map'
import { Box, Heading } from '@chakra-ui/react'
import { Control, FieldErrors, UseFormRegister } from 'react-hook-form'

const ClothesForm = ({
	control,
	register,
	errors,
	product,
}: {
	control: Control<any>
	register: UseFormRegister<any>
	errors: FieldErrors<any>
	product?: ProductEntity
}) => {
	return (
		<>
			<Box
				w='full'
				display='flex'
				justifyContent='start'
				alignItems='center'
				mt='4'
			>
				<Heading
					as='h5'
					fontSize={{ base: 'md', md: 'lg' }}
					color='black'
					fontWeight='900'
				>
					Detalles generales
				</Heading>
			</Box>
			<InputGroupContent
				label='Modelo de la prenda'
				placeholder='Agrega el modelo de la prenda o alguna referencia'
				name='details.general_details.model'
				type='text'
				required
				defaultValue={
					(product &&
						(product?.details?.general_details as GeneralDetailsClothes)
							.model) ||
					''
				}
				register={register}
				errors={errors}
			/>
			<Select
				name='details.general_details.gender'
				label='Genero de la prenda'
				placeholder='Escoge el genero de la prenda'
				options={genderMap}
				defaultValue={
					product &&
					(genderMap.find(
						(obj) =>
							obj.value ===
							((product?.details?.general_details as GeneralDetailsClothes)
								?.gender ?? '')
					) ?? { label: '', value: '' })
				}
				control={control}
				isRequired={true}
			/>
			<Select
				name='details.general_details.age'
				label='Seleciona el rango de eded de la prenda'
				placeholder='Escoge el rango de edad de la prenda'
				options={ageMap}
				defaultValue={
					product &&
					(ageMap.find(
						(obj) =>
							obj.value ===
							((product?.details?.general_details as GeneralDetailsClothes)
								?.age ?? '')
					) ?? { label: '', value: '' })
				}
				control={control}
				isRequired={true}
			/>
			<TextareaGroupContent
				label='Materiales de la prenda'
				placeholder='Ingresa la descripcion de los materiales de la prenda'
				name='details.general_details.materials'
				required
				type='text'
				defaultValue={
					(product &&
						(product?.details?.general_details as GeneralDetailsClothes)
							.materials) ||
					''
				}
				register={register}
				errors={errors}
			/>
		</>
	)
}

export default ClothesForm
